module.exports = __webpack_public_path__ + "static/media/WI4@2x.c579c3b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/WI/WI4@2x.png
// module id = 743
// module chunks = 0